import { render, staticRenderFns } from "./TableActiveTabs.vue?vue&type=template&id=fe45ebb6&scoped=true"
import script from "./TableActiveTabs.vue?vue&type=script&lang=js"
export * from "./TableActiveTabs.vue?vue&type=script&lang=js"
import style0 from "./TableActiveTabs.vue?vue&type=style&index=0&id=fe45ebb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe45ebb6",
  null
  
)

export default component.exports